import type { LocalStorageValue } from "./local-storage.type";

import { useState } from "react";

export const useLocalStorageValue = (
  key: string
): [LocalStorageValue, (value: LocalStorageValue) => void] => {
  const valueOnLoad = localStorage.getItem(key);
  const [value, setValue] = useState<LocalStorageValue>(valueOnLoad);

  const saveValue = (value: LocalStorageValue) => {
    if (!value) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
    setValue(value);
  };

  return [value, saveValue];
};
